import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api, type SessionSummary } from "@/lib/api";
import { useChatStore } from "@/store/chat";

export function HistoryPage() {
  const navigate = useNavigate();
  const setSessionId = useChatStore((s) => s.setSessionId);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["sessions"],
    queryFn: async () => (await api.get<SessionSummary[]>("/sessions")).data,
  });

  function open(id: string) {
    setSessionId(id);
    navigate("/chat");
  }

  return (
    <div className="mx-auto max-w-5xl p-6">
      <h1 className="text-xl font-semibold">History</h1>
      {isLoading && <p className="mt-4 text-sm">Loading…</p>}
      {isError && (
        <p role="alert" className="mt-4 rounded bg-red-50 p-3 text-sm text-red-900">
          Failed to load history: {String(error)}
        </p>
      )}
      {!isLoading && !isError && (data?.length ?? 0) === 0 && (
        <p className="mt-4 text-sm text-datumcraft-slate">No conversations yet.</p>
      )}
      {!isLoading && !isError && (data?.length ?? 0) > 0 && (
        <ul data-tour-id="history-list" className="mt-4 divide-y divide-datumcraft-slate/20 rounded border border-datumcraft-slate/20 bg-white">
          {(data ?? []).map((s) => (
            <li key={s.id}>
              <button
                onClick={() => open(s.id)}
                className="flex w-full items-center justify-between p-3 text-left hover:bg-datumcraft-mist"
              >
                <div>
                  <p className="text-sm font-medium">{s.title ?? s.sessionId}</p>
                  <p className="text-xs text-datumcraft-slate">
                    updated {new Date(s.updatedAt).toLocaleString()}
                  </p>
                </div>
                <span className="text-xs text-datumcraft-slate">Open →</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
